module.exports = __webpack_public_path__ + "static/media/img_minnanyu.5d0ab518.png";